
namespace TabAurous.ECommerce {

    @Serenity.Decorators.registerClass()
    export class ECommRefundDialog extends _Ext.TransDialog<ECommRefundRow, any> {
        protected getFormKey() { return ECommRefundForm.formKey; }
        protected getIdProperty() { return ECommRefundRow.idProperty; }
        protected getLocalTextPrefix() { return ECommRefundRow.localTextPrefix; }
        protected getNameProperty() { return ECommRefundRow.nameProperty; }
        protected getService() { return ECommRefundService.baseUrl; }
        protected getDeletePermission() { return ECommRefundRow.deletePermission; }
        protected getInsertPermission() { return ECommRefundRow.insertPermission; }
        protected getUpdatePermission() { return ECommRefundRow.updatePermission; }
        protected useViewMode() { return true; }

        public form = new ECommRefundForm(this.idPrefix);
        public knockoffvalue;
        constructor() {
            super();
            var Config = Q.deepClone(q.DefualtEditorOptions);
            Config.height = 150;
            q.initItemEditor(this, this.form.ECommRefundDetails, Config);
            q.initItemEditor(this, this.form.PartyBalance, Config);

            this.element.height(800);
            // q.setTextRightAlign(this.form.TdsTotal.element);
            q.hideEditorTab(this.form.ECommRefundDetails);
            q.hideEditorLabel(this.form.ECommRefundDetails);
            q.hideEditorLabel(this.form.PartyBalance);
            //q.setGridEditorHeight(this.form.ECommRefundDetails.element, 100);
            q.setTextRightAlign(this.form.TotalAmount);
            q.hideEditorToolbar(this.form.PartyBalance);
            this.form.POSCustomerId.changeSelect2(e => {
                var customerid = parseInt(this.form.POSCustomerId.value);
                let customerdetails: OMS.PosCustomerMasterRow;
                OMS.PosCustomerMasterService.Retrieve({ EntityId: customerid },
                    response => {
                        if (response.Entity != undefined) {
                            customerdetails = response.Entity;
                            this.form.LedgerName.value = customerdetails.FirstName + customerdetails.LastName;
                            this.form.Mobile.value = customerdetails.Mobile;
                            this.form.Email.value = customerdetails.Email;

                        }
                    }, { async: false })
                ECommRefundService.RefundOrderList({ POSCustomerId: customerid },
                    response => {
                        this.form.PartyBalance.clearCustomerRefund();
                        if (response.Entities != null && response.Entities.length > 0) {
                            this.form.PartyBalance.setCustomerRefund(response.Entities);
                            var refundableamount = 0;

                            for (var i = 0; i < response.Entities.length; i++) {
                                refundableamount += response.Entities[i].TotalAmount;
                            }
                            this.form.RefundECommsible.value = refundableamount;
                        }

                    }, { async: false })
                //set Party Balance Grid based on Ledger Id
                
            });
            this.form.CurrencyId.changeSelect2(e => {
                //set Exchange Rate feild of Detail Grid Dialog
                var ExchangeRate = OMS.ExchangeRateRow.getLookup().items.filter(x => x.CurrencyId.toString() === this.form.CurrencyId.value);
                this.form.ECommRefundDetails.ExchangeRate = ExchangeRate[0].ExchRate;
                this.form.ExchangeRate.value = ExchangeRate[0].ExchRate;
            });
            (this.form.ECommRefundDetails.view as any).onDataChanged.subscribe(() => {
                //set Total Amount on Payment Grid Change 
                var amt = 0;
                for (var k of this.form.ECommRefundDetails.getItems()) {
                    amt += k.Amount;
                }
                this.form.TotalAmount.value = amt;
                this.form.PartyBalance.amount = amt;
                if (this.form.ECommRefundDetails.getItems().length > 0)
                    q.showAndDisableField(this.form.POSCustomerId);
                else if (this.form.ECommRefundDetails.getItems().length == 0)
                    q.showAndSetRequiredField(this.form.POSCustomerId);
            });

            (this.form.PartyBalance.view as any).onRowCountChanged.subscribe(() => {
                //set Total Amount on Payment Grid Change

                if (this.form != undefined) {
                    var amt = 0;
                    for (var k of this.form.ECommRefundDetails.getItems()) {
                        amt += k.Amount;
                    }
                    this.form.TotalAmount.value = amt;
                    this.form.PartyBalance.amount = amt;

                }
                if (this.form.ECommRefundDetails.getItems().length > 0) {
                    this.form.POSCustomerId.set_readOnly(true);
                } else {
                    this.form.POSCustomerId.set_readOnly(false);
                }
            });
            (this.form.PartyBalance.view as any).onRowCountChanged.subscribe(() => {

                //calculate knock off value of the Knock Off Grid/Party Balance Grid
                var ntamt = 0;
                var dueamt = 0;
                for (var x of this.form.PartyBalance.getItems()) {
                    if (x.KnockOff != undefined) {
                        ntamt = ntamt + x.KnockOff;
                    }
                    dueamt = dueamt + x.Due;
                }
            });
            this.form.RefundTotal.addValidationRule(this.uniqueName, e => {
                //Validate that the knock off value is not less than or greater than total Amount 
                if (this.form.RefundTotal.value != this.form.TotalAmount.value)
                    return "Refund Total values and total amount should match";
            });
            this.validateForm();
        }
        calculatePartyBalance() {
            var refundvalues: Finance.PartyBalanceRow[] = this.form.PartyBalance.view.getItems();
            var totalrefund = 0;
            for (var i = 0; i < refundvalues.length; i++) {
                if (refundvalues[i].CheckRefund)
                    totalrefund += refundvalues[i].TotalAmount;
            }
            this.form.RefundTotal.value = totalrefund;
        }
        protected onDialogOpen() {
            super.onDialogOpen();

            if (this.form.POSCustomerId.value != "") {
                //set Party Balance Grid in Edit Mode 
                var ExchangeRate = OMS.ExchangeRateRow.getLookup().items.filter(x => x.CurrencyId.toString() === this.form.CurrencyId.value);
                this.form.ExchangeRate.value = ExchangeRate[0].ExchRate;
                this.form.ECommRefundDetails.ExchangeRate = ExchangeRate[0].ExchRate;
                //new paymentdetailsdialog().ExchangeRate = 1; 

            }
            else {
                //set Default Values based on Login
                this.form.EnteredBy.value = Q.Authorization.userDefinition.Username;
                Serenity.EditorUtils.setReadOnly(this.form.EnteredBy, true);
                this.form.UserId.value = Q.Authorization.userDefinition.UserId;
                this.form.CurrencyId.value = Q.Authorization.userDefinition.CurrencyId.toString();
                var ExchangeRate = OMS.ExchangeRateRow.getLookup().items.filter(x => x.CurrencyId.toString() === this.form.CurrencyId.value);
                this.form.ECommRefundDetails.ExchangeRate = ExchangeRate[0].ExchRate;
                this.form.ExchangeRate.value = ExchangeRate[0].ExchRate;
            }

        }

        protected onDialogClose() {
            closed = true;
        }
        protected afterLoadEntity() {
            super.afterLoadEntity();

        }


        protected getToolbarButtons(): Serenity.ToolButton[] {
            let btns = super.getToolbarButtons();

            //Edit Click Override
            var btnEdit = Q.first(btns, x => x.cssClass == "edit-button");
            var oldEditClick = btnEdit.onClick;
            btnEdit.onClick = e => { this.confirmBeforeEdit(oldEditClick, e); };



            return btns;
        }
        // **** Validate Reference of Voucher in Stock Transaction Before Edit. ****
        private confirmBeforeEdit(oldEvt, e) {
            let self = this;
            Q.alert("This Voucher Cannot be Edited!");
            return;

        }
         
    }




}
